import apiFetch from '../../apiFetch'

export default function (verracosNoMostrar, token) {
  return apiFetch({endPoint: `GrupoVerraco/getVerracoGrupoVerracoList`, method: 'POST', body: verracosNoMostrar, token: token})
}
